<div class="product_image-textCenter fluad_adjuvant-imagecenter" *ngIf=" node1 | async as item">
    <div class="container">
        <div class="product_image-textcontainer">
            <div class="product_image-textHeader" [innerHTML]="item.headLine"></div>
            <div class="product_image-text1" [innerHTML]="item.textContent"></div>
            <div class="product_box1-disclaimer" [innerHTML]="item.bottomContent"></div>
            <!-- <a [href]="downloadPdf(item.mediaPdf.url)" target="_blank"> <span>{{item.pdfText}}</span>
                <img alt="Download" src="../../../app/../assets/images/product_download_icon.svg"></a> -->
        </div>
        <div class="simple-banner banner__component--responsive">
            <img class="js-responsive-image animate-shield3" [attr.alt]="item.media?.altText" [attr.title]="item.media?.altText" [src]="getImage(item.media)">
        </div>
        <div class="simple-banner-mobile banner__component--responsive-mobile">
            <img class="js-responsive-image-mobile animate-shield3" [attr.alt]="item.media?.altText" [attr.title]="item.media?.altText"
                [src]="getMobileImage(item.media)">
        </div>
    </div>
    <!-- <div class="product_box1-disclaimer">{{item.bottomContent}}</div> -->
</div>



